import '@mrhenry/wp--bugsnag-config';

import { MrInputSink } from '@mrhenry/wp--mr-interactive';

import './modules/locations-map';
import './modules/mr-navigation-overlay';

customElements.define( 'mr-input-sink', MrInputSink );
